import React from 'react';
import { formatNumber } from '../../../../app-actions';
import './total-trade-section.css';

const TotalTradeSection = (props) => {
  const {
    authorableContent: {
      totalTradeInValueText: currentFundValueText,
      fundContributionText: amFundContributionText,
      addOnsText,
    },
    fundContributionValue,
    currentFundValue,
    addonCosts,
  } = props;

  return (
    <React.Fragment>
      <div id="total-trade-section" className="total-trade-section row">
        <div className="col-md-4 section left">
          <div className="col-md-12 heading">
            {currentFundValueText}
          </div>
          <div className="col-md-12 body">
            <span className="currency">$</span>
            <span>{formatNumber(currentFundValue, 2)}</span>
          </div>
        </div>
        <div className="col-md-4 section right">
          <div className="col-md-12 heading">
            <span>{amFundContributionText}</span>
          </div>
          <div className="col-md-12 body">
            <span className="currency">$</span>
            <span>{formatNumber(fundContributionValue, 2)}</span>
          </div>
        </div>
        <div className="col-md-4 section right">
          <div className="col-md-12 heading">
            <span>{addOnsText}</span>
          </div>
          <div className="col-md-12 body">
            <span className="currency">$</span>
            <span>{formatNumber(addonCosts, 2)}</span>
            <span className="asterisk-sub">/month</span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TotalTradeSection;
